import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CardInfo from '../../components/cards/CardInfo';
import MainLayout, { LayoutHeading } from '../../components/MainLayout';
import { Paragraph } from '../../components/Styled/typography';
import { t } from '../../translations/getTranslation';
import useAccountSummary from '../../hooks/useAccountSummary';
import useAnalytics from '../../hooks/useAnalytics';
const CloseConfirmation = () => {
    const { isSuccess, isSemu } = useAccountSummary();
    useAnalytics(isSuccess, { isSemu });
    return (_jsxs("div", Object.assign({ "data-cy": "close-confirmation-view" }, { children: [_jsx(CardInfo, {}), _jsxs(MainLayout, Object.assign({ withImage: true }, { children: [_jsx(LayoutHeading, { title: t('closeConfirmation.closingWillCancel'), modalImageProps: {
                            imageName: 'WARNING'
                        } }), _jsx(Paragraph, { children: t('closeConfirmation.yourProgressWillNot') })] }))] })));
};
export default CloseConfirmation;
//# sourceMappingURL=index.js.map